/**
 * Created by eriksundqvist on 24/05/16.
 */
import * as type from './action-types';

const initialState = {
  userId: null,
  taxId: 1,
  customerEntity: null,
  customerId: 0,
  couponId: '',
  coupon: null,
  currencyId: 0,
  currencyName: '',
  currencyAmount: 0,
  displayDates: 0,
  displayHours: 0,
  preReport: false,
  preReportedAt: null,
  amount: 0,
  specification: '',
  saveVacationPay: null,
  invoiceUser: [],
  invoiceDate: [],
  sendToEmailBool: true, // Send letter or email
  sendToEmail: '', // The email address
  sendToEmailSecondary: '',
  companyPhone: '',
  supplierLedger: [],
  taxkeyId: null,
  expressPayment: false,
  invoiceId: null,
  amountIncVat: 0,
  lockAmountDistribution: {},
  hsd: {
    rot: false,
    rut: false,
    data: '',
    apartmentNumber: '',
    cooperativeApartmentRegistrationNumber: '',
    accommodationType: ''
  },
  supplierLedgers: {
    supplierName: null,
    invoiceId: null,
    userIdCreator: null,
    taxId: null,
    type: null
  },
  submitted: false,
  termsAccepted: false,
  valid: false,
  posting: false,
  postError: false,
  initializing: false,
  manualInvoiceCalc: false,
  showDateOnInvoice: false,
  showHoursOnInvoice: false,
  messageType: 'email',
  surveys: {
    questions_and_answers: '',
    status: ''
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.SET_AMOUNT:
      return Object.assign({}, state, {
        amount: (action.payload) ? +(action.payload) : 0
      });

    case type.SET_CUSTOMER_ENTITY:
      return Object.assign({}, state, {
        customerEntity: action.payload
      });

    case type.SET_COUPON_ID:
      return Object.assign({}, state, {
        couponId: action.payload
      });

    case type.SET_COUPON:
      return Object.assign({}, state, {
        coupon: action.payload
      });

    case type.CLEAR_COUPON:
      return Object.assign({}, state, {
        coupon: null
      });

    case type.SET_CURRENCY_ID:
      return Object.assign({}, state, {
        currencyId: action.payload
      });

    case type.SET_CURRENCY_NAME:
      return Object.assign({}, state, {
        currencyName: action.payload
      });

    case type.SET_CURRENCY_AMOUNT:
      return Object.assign({}, state, {
        currencyAmount: (action.payload) ? +(action.payload) : 0
      });

    case type.SET_SPECIFICATION:
      return Object.assign({}, state, {
        specification: action.payload
      });

    case type.SET_INVOICEDATE:
      return Object.assign({}, state, {
        invoiceDate: action.payload
      });

    case type.SET_USER_ID:
      return Object.assign({}, state, {
        userId: action.payload
      });

    case type.SET_TAX_ID:
      return Object.assign({}, state, {
        taxId: action.payload
      });

    case type.SET_SAVE_VACATION_PAY:
      return Object.assign({}, state, {
        saveVacationPay: action.payload
      });

    case type.SET_INVOICEUSER:
      return Object.assign({}, state, {
        invoiceUser: action.payload
      });

    case type.SET_SEND_TO_EMAIL:
      return Object.assign({}, state, {
        sendToEmail: action.payload
      });

    case type.SET_SEND_TO_EMAIL_SECONDARY:
      return Object.assign({}, state, {
        sendToEmailSecondary: action.payload
      });

    case type.SET_SEND_TO_EMAIL_BOOL:
      return Object.assign({}, state, {
        sendToEmailBool: action.payload
      });

    case type.SET_COMPANY_PHONE:
      return Object.assign({}, state, {
        companyPhone: action.payload
      });

    case type.SET_EINVOICE_ADDRESS:
      return Object.assign({}, state, {
        einvoiceAddress: action.payload
      });

    case type.SET_PO_NUMBER:
      return Object.assign({}, state, {
        poNumber: action.payload
      });

    case type.SET_TAX_KEY_ID:
      return Object.assign({}, state, {
        taxkeyId: action.payload
      });

    case type.SET_EXPRESS_PAYMENT:
      return Object.assign({}, state, {
        expressPayment: action.payload
      });

    case type.SET_INVOICE_ID:
      return Object.assign({}, state, {
        invoiceId: action.payload
      });

    case type.SET_CUSTOMER_ID:
      return Object.assign({}, state, {
        customerId: action.payload
      });

    case type.SET_SUPPLIER_LEDGER:
      return Object.assign({}, state, {
        supplierLedger: action.payload
      });

    case type.SET_SUBMITTED:
      return Object.assign({}, state, {
        submitted: action.payload
      });

    case type.SET_VALID:
      return Object.assign({}, state, {
        valid: action.payload
      });

    case type.SET_POSTING:
      return Object.assign({}, state, {
        posting: action.payload
      });

    case type.SET_POST_ERROR:
      return Object.assign({}, state, {
        postError: action.payload
      });

    case type.SET_AMOUNT_INC_VAT:
      return Object.assign({}, state, {
        amountIncVat: action.payload
      });

    case type.SET_LOCK_AMOUNT_DISTRIBUTION:
      return Object.assign({}, state, {
        lockAmountDistribution: action.payload
      });

    case type.SET_INITIALIZING:
      return Object.assign({}, state, {
        initializing: action.payload
      });

    case type.SET_AMOUNT_AFTER_HSD:
      return Object.assign({}, state, {
        amountAfterHsd: action.payload
      });

    case type.CLEAR:
      return Object.assign({}, initialState);

    case type.SET_ROT:
      return Object.assign({}, state, {
        hsd: {
          rut: false,
          ...action.payload
        }
      });

    case type.SET_RUT:
      return Object.assign({}, state, {
        hsd: {
          rot: false,
          data: '',
          rut: action.payload
        }
      });

    case type.SET_MANUAL_INVOICE_CALC:
      return Object.assign({}, state, {
        manualInvoiceCalc: action.payload
      });

    case type.SET_DISPLAY_DATES:
      return Object.assign({}, state, {
        displayDates: action.payload
      });

    case type.SET_DISPLAY_HOURS:
      return Object.assign({}, state, {
        displayHours: action.payload
      });

    case type.SET_PREREPORT:
      return Object.assign({}, state, {
        preReport: action.payload
      });

    case type.SET_PREREPORTED_AT:
      return Object.assign({}, state, {
        preReportedAt: action.payload
      });

    case type.SET_TERMSACCEPTED:
      return Object.assign({}, state, {
        termsAccepted: action.payload
      });

    case type.SET_LOGGED_IN_INVOICE_USER_TAXKEYS:
      return Object.assign({}, state, {
        invoiceUser: state.invoiceUser.map((invoiceUser, index) => {
          if (index === 0) {
            return Object.assign({}, invoiceUser, { taxkeys: action.payload });
          } else {
            return invoiceUser;
          }
        })
      });

    case type.SET_LOGGED_IN_INVOICE_USER_TAXKEY_ID:
      return Object.assign({}, state, {
        invoiceUser: state.invoiceUser.map((invoiceUser, index) => {
          if (index === 0) {
            return Object.assign({}, invoiceUser, { taxkeyId: action.payload });
          } else {
            return invoiceUser;
          }
        })
      });

    case type.SET_MESSAGE_TYPE:
      return {
        ...state,
        messageType: action.payload
      };

    case type.SET_SURVEY_ANSWERS:
      return {
        ...state,
        surveys: action.payload
      };

    default:
      return state;
  }
};



/** WEBPACK FOOTER **
 ** ./src/redux/modules/invoice/reducer.js
 **/